export class FieldLength {
    public static EMAIL_MAX = 60;
    public static FIRST_NAME_MAX = 20;
    public static LAST_NAME_MAX = 20;
    public static PHONE_MAX = 30;
    public static PASSWORD_MIN = 8;
    public static PASSWORD_MAX = 60;
}
